import { defaultApi } from '@/api';
import { components } from '@/types/api';

export async function getUserList() {
  const { data } = await defaultApi.get<components['schemas']['User'][]>('/users');
  return data;
}
